import React from "react"
import { useSelector } from "react-redux"
import { SidebarItem } from "../SidebarItem"

import "./index.scss"

export function ListSearchResults({ handleClickCase }) {
  const { searchResults } = useSelector((state) => state.crm)

  function formatResults(results) {
    const formattedResults = results.map((currentResult) => ({
      caseId: currentResult?.case_id,
      clientName: currentResult.corporate_name,
      lastMessage: "Segue o comprovante de pagamento do caso",
      lastMessageDate: currentResult.updated,
      createdAt: currentResult.created,
      viewed: currentResult.viewed_company === 0 ? false : true,
      status: currentResult.status,
    }))

    return formattedResults
  }

  return (
    <div className="search-results">
      {searchResults.corporate_name?.length > 0 && (
        <div className="search-results__result">
          <h2>Nome</h2>
          {formatResults(searchResults.corporate_name).map((item, index) => (
            <SidebarItem
              key={item.caseId}
              item={item}
              index={index}
              handleClickCase={handleClickCase}
            />
          ))}
        </div>
      )}

      {searchResults.email?.length > 0 && (
        <div className="search-results__result">
          <h2>Email</h2>
          {formatResults(searchResults.email).map((item, index) => (
            <SidebarItem
              key={item.caseId}
              item={item}
              index={index}
              handleClickCase={handleClickCase}
            />
          ))}
        </div>
      )}

      {searchResults.cpf?.length > 0 && (
        <div className="search-results__result">
          <h2>CPF</h2>
          {formatResults(searchResults.cpf).map((item, index) => (
            <SidebarItem
              key={item.caseId}
              item={item}
              index={index}
              handleClickCase={handleClickCase}
            />
          ))}
        </div>
      )}

      {searchResults.cnpj?.length > 0 && (
        <div className="search-results__result">
          <h2>CNPJ</h2>
          {formatResults(searchResults.cnpj).map((item, index) => (
            <SidebarItem
              key={item.caseId}
              item={item}
              index={index}
              handleClickCase={handleClickCase}
            />
          ))}
        </div>
      )}
    </div>
  )
}
